<template>
    <v-treeview
        open-all
        open-on-click
        dense
        item-disabled="locked"
        :items="items"
        activatable
    >
        <template v-slot:label="{ item }">
            <div @click="clickOnTreeMenuItem(item)">{{ item.name }}</div>
        </template>
    </v-treeview>
</template>

<script>
export default {
    name: "tree-menu",
    data: () => ({
        items: [
            {
                id: 0,
                name: 'Главная',
                route: '/'
            },
            {
                id: 1,
                name: 'Рассылки',
                children: [
                    {
                        id: 10,
                        name: 'Платежи (настройки)',
                        route: '/report'
                    },
                    // {
                    //   id: 11,
                    //   name: 'Гимназия Томь',
                    //   locked: true,
                    //   route: '/gymnasium'
                    // },
                    // {
                    //   id: 12,
                    //   name: 'Субсидии',
                    //   locked: true,
                    //   route: '/subsidy'
                    // },
                    {
                        id: 13,
                        name: 'Платежи (логи)',
                        locked: false,
                        route: '/report/logs'
                    },
                    {
                        id: 18,
                        name: 'Квит. (пользователи)',
                        locked: false,
                        route: '/receipt-email/users'
                    },
                    {
                        id: 19,
                        name: 'Квит. (логи)',
                        locked: false,
                        route: '/receipt-email/logs'
                    },
                ]
            },
            {
                id: 99,
                name: 'Waviot',
                locked: false,
                route: '/waviot'
            },
            {
                id: 100,
                name: 'Шаблоны таблиц',
                locked: false,
                route: '/format_table'
            },
            // {
            //   id: 2,
            //   name: 'Транспорт',
            //   children: [
            //     {
            //       id: 20,
            //       name: 'Сбер',
            //       locked: false,
            //       route: '/transport/sber'
            //     },
            //     {
            //       id: 21,
            //       name: 'Айком',
            //       locked: false,
            //       route: '/transport/ikom'
            //     },
            //     {
            //       id: 22,
            //       name: 'Айком - ТТУ',
            //       locked: false,
            //       route: '/transport/ikom-ttu'
            //     },
            //     {
            //       id: 23,
            //       name: 'Логи',
            //       locked: false,
            //       route: '/transport/logs'
            //     }
            //   ]
            // },
            {
                id: 4,
                name: 'Импорт в биллинг',
                children: [
                    {
                        id: 45,
                        name: 'Перенаправления',
                        locked: false,
                        route: '/forwarding'
                    },
                    {
                        id: 56,
                        name: 'ZIP',
                        locked: false,
                        route: '/generate-zip'
                    },
                    // {
                    //     id: 44,
                    //     name: 'Начисления',
                    //     locked: false,
                    //     route: '/import-billing/charges'
                    // },
                    {
                        id: 43,
                        name: 'Сбер',
                        locked: false,
                        route: '/import-billing/sber'
                    },
                    {
                        id: 40,
                        name: 'Жилсервис',
                        locked: false,
                        route: '/import-billing/gilservice'
                    },
                    // {
                    //   id: 41,
                    //   name: 'УФПС',
                    //   locked: false,
                    //   route: '/import-billing/ufps'
                    // },
                    // {
                    //   id: 42,
                    //   name: 'Логи',
                    //   locked: false,
                    //   route: '/import-billing/logs'
                    // }
                ]
            },
            {
                id: 5,
                name: 'Квитанции',
                route: '/invoices',
            },
            {
                id: 6,
                name: 'История квитанций',
                route: '/invoices-history',
            },
            {
                id: 7,
                name: 'Реестры сбера',
                children: [
                    {
                        id: 8,
                        name: 'Сверка',
                        route: '/sber/resstrs',
                    },
                    {
                        id: 9,
                        name: 'Загрузка',
                        route: '/sber/upload'
                    }
                ],
            },
            {
                id: 11,
                name: 'Права пользователей',
                children: [
                    {
                        id: 14,
                        name: 'Добавление прав',
                        route: '/add_credits',
                    },
                ],
            },
            {
                id: 15,
                name: 'СУЖФ',
                children: [
                    {
                        id: 16,
                        name: 'Импорт помещений',
                        route: '/import-room/suzhf',
                    },
                    {
                        id: 17,
                        name: 'Логи выгрузки в Трасфер',
                        route: '/upload/gis/logs',
                    }
                ],
            },
            // {
            //   id: 3,
            //   name: 'Права',
            //   route: '/rights'
            // },
            // {
            //   id: 5,
            //   name: 'Настройки',
            //   locked: false,
            //   route: '/properties'
            // },
            // {
            //   id: 6,
            //   name: 'Выход',
            //   locked: true,
            //   route: '/logout'
            // }
        ]
    }),
    methods: {
        clickOnTreeMenuItem(item) {
            if (item.route && !item.locked) {
                this.$router.push(item.route)
                    .catch(err => {
                    })
            }
        }
    }
}
</script>

<style scoped>

</style>
